import clsx from 'clsx'
import { NavLink } from 'react-router-dom'

type Props = {
  title: string
  id: number
}

export const Option = ({ title, id }: Props) => {
  return (
    <NavLink
      to={String(id)}
      className={({ isActive }) =>
        clsx('block text-start  text-sm w-full h-[52px] p-4 rounded-2xl', {
          'bg-secondary-dark text-white font-bold': isActive,
          'text-[#777777] font-medium': !isActive,
        })
      }
    >
      <span className="block h-full gap-4 overflow-hidden text-ellipsis whitespace-nowrap">
        {`${id} - ${title}`}
      </span>
    </NavLink>
  )
}
